import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import {
  closeModalEvent,
  sessionExpirationTimeKey,
} from '../../../services/auto-logout.service';
import { LocalisePipe } from '../../pipes/localise.pipe';

@Component({
  selector: 'app-inactive-sessions-dialog',
  templateUrl: './inactive-sessions-dialog.component.html',
  styleUrls: ['./inactive-sessions-dialog.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, LocalisePipe],
})
export class InactiveSessionsDialogComponent implements OnInit, OnDestroy {
  public remainedTime = '00:00';
  private intervalId: any;
  public closeModalEvent = closeModalEvent;

  constructor() {}

  ngOnInit(): void {
    this.updateRemainingTime();

    this.intervalId = setInterval(() => {
      this.updateRemainingTime();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateRemainingTime(): void {
    const expirationTimestamp = localStorage.getItem(sessionExpirationTimeKey);
    if (!expirationTimestamp) {
      return;
    }

    const expirationTime = parseInt(expirationTimestamp, 10);
    const currentTime = Math.floor(Date.now() / 1000);
    const remainingSeconds = expirationTime - currentTime;

    let minutes = Math.floor(remainingSeconds / 60);
    let seconds = remainingSeconds % 60;
    if (minutes < 0) {
      minutes = 0;
    }
    if (seconds < 0) {
      seconds = 0;
    }
    this.remainedTime = `${this.formatTime(minutes)}:${this.formatTime(
      seconds,
    )}`;
  }

  private formatTime(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
}
